// OPEX Breakdown Details
export const opexBreakdownData = {
  2024: {
    total: 167,
    categories: [
      { name: { pt: "CMVMC", en: "COGS" }, value: 58, percentage: 34.7 },
      { name: { pt: "Custos com Pessoal", en: "Personnel Costs" }, value: 54, percentage: 32.3 },
      { name: { pt: "Subcontratos", en: "Subcontracts" }, value: 5, percentage: 3.0 },
      { name: { pt: "Gerais e Administrativos", en: "General & Administrative" }, value: 28, percentage: 16.8 },
      { name: { pt: "Custos de Comercialização", en: "Commercial Costs" }, value: 22, percentage: 13.2 },
    ],
    ratios: {
      opexToRevenue: 68.2,
      personnelToRevenue: 22.0,
      materialsToRevenue: 23.7,
    },
  },
  2025: {
    total: 196,
    categories: [
      { name: { pt: "CMVMC", en: "COGS" }, value: 64.6, percentage: 33.0 },
      { name: { pt: "Custos com Pessoal", en: "Personnel Costs" }, value: 65, percentage: 33.2 },
      { name: { pt: "Subcontratos", en: "Subcontracts" }, value: 5.3, percentage: 2.7 },
      { name: { pt: "Gerais e Administrativos", en: "General & Administrative" }, value: 35.6, percentage: 18.2 },
      { name: { pt: "Custos de Comercialização", en: "Commercial Costs" }, value: 25.5, percentage: 13.0 },
    ],
    ratios: {
      opexToRevenue: 65.8,
      personnelToRevenue: 21.8,
      materialsToRevenue: 21.7,
    },
  },
  2026: {
    total: 194,
    categories: [
      { name: { pt: "CMVMC", en: "COGS" }, value: 62, percentage: 32.0 },
      { name: { pt: "Custos com Pessoal", en: "Personnel Costs" }, value: 69, percentage: 35.6 },
      { name: { pt: "Subcontratos", en: "Subcontracts" }, value: 5, percentage: 2.6 },
      { name: { pt: "Gerais e Administrativos", en: "General & Administrative" }, value: 34, percentage: 17.5 },
      { name: { pt: "Custos de Comercialização", en: "Commercial Costs" }, value: 24, percentage: 12.4 },
    ],
    ratios: {
      opexToRevenue: 62.2,
      personnelToRevenue: 22.1,
      materialsToRevenue: 19.9,
    },
  },
};

// Monthly OPEX data
export const monthlyOpexData = {
  2024: [
    { month: 'Jan', opex: 13.2 }, { month: 'Feb', opex: 13.5 }, { month: 'Mar', opex: 14.1 },
    { month: 'Apr', opex: 13.8 }, { month: 'May', opex: 14.0 }, { month: 'Jun', opex: 14.2 },
    { month: 'Jul', opex: 13.6 }, { month: 'Aug', opex: 13.4 }, { month: 'Sep', opex: 14.0 },
    { month: 'Oct', opex: 14.3 }, { month: 'Nov', opex: 14.1 }, { month: 'Dec', opex: 14.8 },
  ],
  2025: [
    { month: 'Jan', opex: 15.5 }, { month: 'Feb', opex: 15.8 }, { month: 'Mar', opex: 16.5 },
    { month: 'Apr', opex: 16.2 }, { month: 'May', opex: 16.0 }, { month: 'Jun', opex: 16.8 },
    { month: 'Jul', opex: 16.4 }, { month: 'Aug', opex: 16.2 }, { month: 'Sep', opex: 16.5 },
    { month: 'Oct', opex: 17.0 }, { month: 'Nov', opex: 16.8 }, { month: 'Dec', opex: 16.3 },
  ],
  2026: [
    { month: 'Jan', opex: 15.8 }, { month: 'Feb', opex: 16.0 }, { month: 'Mar', opex: 16.2 },
    { month: 'Apr', opex: 16.0 }, { month: 'May', opex: 15.8 }, { month: 'Jun', opex: 16.5 },
    { month: 'Jul', opex: 16.2 }, { month: 'Aug', opex: 16.0 }, { month: 'Sep', opex: 16.2 },
    { month: 'Oct', opex: 16.5 }, { month: 'Nov', opex: 16.3 }, { month: 'Dec', opex: 16.5 },
  ],
};

// Monthly Net Income data
export const monthlyNetIncomeData = {
  2024: [
    { month: 'Jan', netIncome: 2.8 }, { month: 'Feb', netIncome: 3.2 }, { month: 'Mar', netIncome: 3.5 },
    { month: 'Apr', netIncome: 3.3 }, { month: 'May', netIncome: 3.0 }, { month: 'Jun', netIncome: 3.6 },
    { month: 'Jul', netIncome: 3.2 }, { month: 'Aug', netIncome: 2.9 }, { month: 'Sep', netIncome: 3.1 },
    { month: 'Oct', netIncome: 3.4 }, { month: 'Nov', netIncome: 3.2 }, { month: 'Dec', netIncome: 3.8 },
  ],
  2025: [
    { month: 'Jan', netIncome: 4.0 }, { month: 'Feb', netIncome: 4.3 }, { month: 'Mar', netIncome: 5.2 },
    { month: 'Apr', netIncome: 4.8 }, { month: 'May', netIncome: 4.5 }, { month: 'Jun', netIncome: 5.4 },
    { month: 'Jul', netIncome: 4.6 }, { month: 'Aug', netIncome: 4.2 }, { month: 'Sep', netIncome: 4.4 },
    { month: 'Oct', netIncome: 4.9 }, { month: 'Nov', netIncome: 4.5 }, { month: 'Dec', netIncome: 4.7 },
  ],
  2026: [
    { month: 'Jan', netIncome: 4.8 }, { month: 'Feb', netIncome: 5.2 }, { month: 'Mar', netIncome: 6.5 },
    { month: 'Apr', netIncome: 5.8 }, { month: 'May', netIncome: 5.4 }, { month: 'Jun', netIncome: 6.2 },
    { month: 'Jul', netIncome: 5.5 }, { month: 'Aug', netIncome: 5.0 }, { month: 'Sep', netIncome: 5.2 },
    { month: 'Oct', netIncome: 5.6 }, { month: 'Nov', netIncome: 5.2 }, { month: 'Dec', netIncome: 4.8 },
  ],
};
